import React from 'react';
import ReportFrame from '../ReportFrame';

export default class AssignmentLineItemFeeRevenueByIndustry extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const reportParams = {};
    return (
      <div className='contentwrapper bg-white'>
        <ReportFrame
          DynamicParams={['ReportType']}
          reportName='Revenue Metrics - Assignments And Line Items Fee Revenue by Industry'
          reportParams={reportParams}
          id='assignmentslineitemsfeerevenuebyindustry'
          name='assignmentslineitemsfeerevenuebyindustry'
          title='Assgn. + Ln. I. Fee Revenue by Ind.'
        />
      </div>
    );
  }
}
